import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Trans } from 'react-i18next';
import { Theme } from '@app/theme';
import { Session } from '@app/api';
import { Button } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  emptyContent: {
    textAlign: 'center',
    backgroundColor: theme.colors.white,
    padding: theme.marginBase * 4,
    borderRadius: theme.borderRadius.std,
    marginTop: theme.marginBase * 3,
  },
  emptyTitle: {
    ...theme.fonts.h5,
  },
  emptyButton: {
    marginTop: theme.marginBase * 2,
  },
  emptyButtonIcon: {
    marginRight: theme.marginBase,
    fontSize: 22,
  },
}));

interface Props {
  filter: string;
  session: Session;
}

export const EmptyAppointmentList = ({ filter, session }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.emptyContent}>
      <h4 className={classes.emptyTitle}>
        <Trans i18nKey={`sessions.details.emptyTitle.${filter}`} />
      </h4>
      {filter !== 'past' && (
        <Button
          to={`/sessions/edit/${session.id}#timeslot`}
          color="blue"
          variant="muted"
          className={classes.emptyButton}
        >
          <i className={classnames(classes.emptyButtonIcon, 'ri-edit-line')} />
          <Trans i18nKey={`sessions.details.emptyButton.${filter}`} />
        </Button>
      )}
    </div>
  );
};
